import React, { useEffect, useRef, useState } from "react";
import { Backdrop, Dialog } from "@mui/material";

import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import { ReactComponent as CheckIcon } from "assets/img/svg/check-circle.svg";
import { ReactComponent as ErrorIcon } from "assets/img/svg/WarningRed.svg";

import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import ALoader from "views/pages/manage/common/a-loader";

import {
  DETAILS_ABSENT_MSG,
  DUPLICATE_RFID_MSG,
  INVALID_RFID_MSG,
  LIST_STYLES,
  SCANNED_COUNT_STYLES,
  getPsidFromRfid,
} from "./helper";

const ScanRfid = ({
  open,
  isLoading,
  closeDialog,
  rowData,
  saveConsentStatus,
  scannedRows,
  totalFetchedRows,
}) => {
  const inputRef = useRef(null);
  const [rfid, setRfid] = useState("");

  const [scannedRfids, setScannedRfids] = useState([]); //[{rfid:'', psid:'', applicationId:'', isVerifiedSucess:true/false}]

  useEffect(() => {
    setTimeout(() => {
      focusInput();
    }, 500);
  }, []);

  const focusInput = () => {
    setRfid("");
    inputRef.current.focus();
  };

  const onKeyDownHandler = async (e) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      if (rfid) validateRfid();
      else failureToast(INVALID_RFID_MSG);
    }
  };

  const validateRfid = async () => {
    const isRfidDuplicate = scannedRfids.find(
      (item) => item.rfid === rfid && item.isVerifiedSucess
    );

    if (isRfidDuplicate) {
      DUPLICATE_RFID_MSG(rfid);
      return;
    }

    const psidDetails = await getPsidFromRfid({ rfid });
    if (!psidDetails) return;

    const psid = psidDetails.psid;

    const studentDetails = rowData.filter(
      (item) => item.psid === psid && item.isEligibleForScan
    );

    if (!studentDetails.length) {
      failureToast(DETAILS_ABSENT_MSG);
      return;
    }

    const payload = studentDetails.map((item) => ({
      rfid,
      psid,
      applicationId: item.applicationId,
      isVerifiedSucess: true,
      materialId: item.materialId,
    }));

    setScannedRfids([...scannedRfids, ...payload]);

    focusInput();
  };

  const savePsidDetails = () => {
    if (scannedRfids.length) saveConsentStatus(scannedRfids);
    else closeDialog();
  };

  return (
    <Dialog
      aria-label="Scan ID Cards to capture RFID"
      open={open}
      PaperProps={{
        sx: {
          minHeight: "400px",
          minWidth: "500px",
          maxWidth: "unset",
          borderRadius: "12px",
          padding: "20px",
        },
      }}
    >
      <div
        // style={titleStyles}
        className="d-flex justify-content-between align-items-center mb-3"
      >
        <h3 className="mb-0 text-bold">Scan ID Cards to capture RFID</h3>

        <div className="d-flex align-items-center">
          <div style={SCANNED_COUNT_STYLES}>
            <p className="text-xs mb-0">
              <span className="text-primary">
                {scannedRfids.length + scannedRows.current}
              </span>
              /{totalFetchedRows} Scanned
            </p>
          </div>

          <IconButtonWrapper
            aria-label="Close the dialog"
            //   tabIndex="0"
            onClick={closeDialog}
            disabled={isLoading}
          >
            <CrossIcon />
          </IconButtonWrapper>
        </div>
      </div>

      <section>
        <AInput
          type="text"
          value={rfid}
          handler={(value) => {
            setRfid(value);
          }}
          labelStyle={{ marginBottom: 0 }}
          onKeyDown={onKeyDownHandler}
          placeholder="Scan RFID here & hit Enter"
          innerRef={inputRef}
        />

        <div className="my-4">
          {[
            ...new Map(scannedRfids.map((item) => [item.psid, item])).values(),
          ].map(({ rfid, psid }) => (
            <li
              className="d-flex justify-content-between align-items-center mb-2 p-2"
              style={LIST_STYLES}
              key={rfid}
            >
              <div className="d-flex align-items-center">
                <CheckIcon />
                <p className="text-sm mb-0 ml-2">{psid}</p>
              </div>

              <span className="text-sm" style={{ color: "#676767" }}>
                {rfid}
              </span>
            </li>
          ))}
        </div>
      </section>

      <footer className="mt-auto ml-auto">
        <a onClick={closeDialog}>Cancel</a>

        <AButton variant="primary_filled" size="sm" onClick={savePsidDetails}>
          Confirm
        </AButton>
      </footer>

      {isLoading && (
        <Backdrop
          sx={(theme) => ({
            color: "#fff",
            zIndex: theme.zIndex.drawer + 1300,
          })}
          open={isLoading}
        >
          <ALoader />
        </Backdrop>
      )}
    </Dialog>
  );
};

export default ScanRfid;
